import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import ServicesPage from "./pages/ServicesPage";
import Portfolio from "./pages/Portfolio";
import Journal from "./pages/Journal";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import CookiePolicy from "./pages/CookiePolicy";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import QuotationList from "./pages/QuotationList";
import QuotationEditor from "./pages/QuotationEditor";
import QuotationPrint from "./pages/QuotationPrint";
import ChatWidget from "./components/ChatWidget";
import CookieConsentBanner from "./components/CookieConsentBanner";
import { Toaster } from "./components/ui/toaster";
import { initSession, trackPageview, attachScrollTracker } from "./lib/analytics";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function AnalyticsBridge() {
  const { pathname } = useLocation();
  useEffect(() => {
    // Don't track admin pages
    if (pathname.startsWith("/admin")) return;
    (async () => {
      await initSession();
      await trackPageview(pathname);
    })();
  }, [pathname, initSession, trackPageview]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Header />
      <main>{children}</main>
      <Footer />
      <ChatWidget />
      <CookieConsentBanner />
    </>
  );
}

function App() {
  useEffect(() => {
    const detach = attachScrollTracker();
    return detach;
  }, [attachScrollTracker]);

  return (
    <div className="App grain">
      <BrowserRouter>
        <ScrollTop />
        <AnalyticsBridge />
        <Routes>
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/quotations" element={<QuotationList />} />
          <Route path="/admin/quotations/:id/print" element={<QuotationPrint />} />
          <Route path="/admin/quotations/:id" element={<QuotationEditor />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route
            path="/"
            element={
              <PublicLayout>
                <Home />
              </PublicLayout>
            }
          />
          <Route
            path="/about"
            element={
              <PublicLayout>
                <About />
              </PublicLayout>
            }
          />
          <Route
            path="/weddings"
            element={
              <PublicLayout>
                <ServicesPage kind="weddings" />
              </PublicLayout>
            }
          />
          <Route
            path="/events"
            element={
              <PublicLayout>
                <ServicesPage kind="events" />
              </PublicLayout>
            }
          />
          <Route
            path="/portfolio"
            element={
              <PublicLayout>
                <Portfolio />
              </PublicLayout>
            }
          />
          <Route
            path="/journal"
            element={
              <PublicLayout>
                <Journal />
              </PublicLayout>
            }
          />
          <Route
            path="/contact"
            element={
              <PublicLayout>
                <Contact />
              </PublicLayout>
            }
          />
          <Route
            path="/services"
            element={
              <PublicLayout>
                <Services />
              </PublicLayout>
            }
          />
          <Route
            path="/privacy"
            element={
              <PublicLayout>
                <Privacy />
              </PublicLayout>
            }
          />
          <Route
            path="/terms"
            element={
              <PublicLayout>
                <Terms />
              </PublicLayout>
            }
          />
          <Route
            path="/cookie-policy"
            element={
              <PublicLayout>
                <CookiePolicy />
              </PublicLayout>
            }
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
